export default theme => ({
  content:{
    backgroundColor:"white"
  },
  sizeTemplate:{
    width:"95%",
    paddingLeft:"45px"
  },
  alignLeft:{
    textAlign:"left",
    paddingLeft:"20px !important"
  },
  alignCenter:{
    textAlign:"center"
  },
  alignRight:{
    textAlign:"right"
  },
  contentWidth:{
    width:"90%"
  },
  buttonSave:{
    backgroundColor:"#ff4500",
    color:"white"
  },
  textGrey:{
    color:"#66788A"
  },
  labelFont:1,style:{
    "&.MuiFormLabel-root": {
      fontSize:"12px"
    },
  },
  textError:{
    color:"#ff4500"
  },
  img:{
    width:"55px",
    maxWidth: "80px",
    height:"55px",
    maxHeight: "80px"
  },
  success:{
    backgroundColor: "green",
    height: "30px",
    paddingTop: "4px",
    color:"white"
  },
  uploadArea: {
    marginBottom: 16,
  },
  fileInput: {
    display: 'none',
  },
  uploadLabel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    border: '2px dashed #c9cdd4',
    borderRadius: 10,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    backgroundColor: '#f5f7fa',
    '&:hover': {
      borderColor: '#e94560',
      backgroundColor: 'rgba(233, 69, 96, 0.05)',
    },
  },
  uploadIcon: {
    fontSize: 36,
    color: '#8892a0',
    marginBottom: 8,
  },
  imagePreview: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',
    backgroundColor: '#ffffff',
    borderRadius: 10,
    border: '1px solid #e8eaf0',
  },
  img: {
    width: 80,
    height: 80,
    objectFit: 'contain',
    borderRadius: 8,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  },
});
